import React, { useMemo, useState } from "react";
import ADataGrid from "views/pages/manage/common/data-grid/ADataGrid";
import AButton from "views/pages/manage/common/form-fields-mui/AButton";
import { ReactComponent as WarningInfoCircle } from "assets/img/svg/warningInfoCircle.svg";

import Footer from "../Footer";
import AInput from "../../../../views/pages/manage/common/formFeilds/customInput/AInput";
import {
  formatTransferInItems,
  formatTransferOutTax,
  inputHeight,
} from "../utils";
import { useWizard } from "../../../../components/wizard/WizardContext";
import {
  useFetchTransferInSummary,
  useFetchAdjustmentInSummary,
} from "../../customHooks";
import { createTransferApprovalRequest, tInColumns } from "./constant";
import ALoader from "../../../../views/pages/manage/common/a-loader";
import { transferApi } from "../../apis";
import ViewAdjustmentsButton from "./viewSummaryDetails";
import { formattedPrice } from "views/pages/manage/unAssigned/collectPayment/utils";
import { useModal } from "../../../../contexts/customModal";
import SuccessAlert from "./SuccessAlert";
import ApplyMiscChargesAlert from "./ApplyMiscChargesAlert";
import { useGetChequeDetails } from "../../../paymentManagement/cheque-management/hooks/useDepositCheque";
import ShowPendingCheques from "../../../paymentManagement/cheque-management/components/ShowPendingCheques";
const VerifyPaymentsCard = ({ data }) => {
  const [isLoading, setIsLoading] = useState(false);
  const { values, updateValues, setSearchWizard, next } = useWizard();
  const { showModal, hideModal } = useModal();
  const { selectedStudent, transferDetails } = values;
  const { businessAreaDispVal, applicationId } = selectedStudent;
  const { rows, loading, tInBalanceAmount } = useFetchTransferInSummary(
    applicationId,
    businessAreaDispVal
  );

  const { chequeReceipts } = useGetChequeDetails({ applicationId});

  const { summary: adjustmentData, loading: adjustmentLoading } =
    useFetchAdjustmentInSummary(transferDetails, selectedStudent);
  const groupedData = useMemo(
    () => ({
      TRANSFER_OUT: formatTransferOutTax(rows),
      TRANSFER_IN: formatTransferInItems(adjustmentData?.itemTypeDetails, rows),
    }),
    [adjustmentData, rows]
  );
  console.log(values, "values");
  const handleClose = () => {
    hideModal(false);
    updateValues("transferDetails", {});
    updateValues("selectedStudent", {});
    next(0);
    updateValues("searchStudentsListing", {
      list: [],
      currentPage: 0,
      totalPage: 0,
      totalRecords: 0,
    });
    updateValues("searchStudentsFilters", {});
    setSearchWizard((prev) => ({ ...prev, isShow: true }));
  };

  const showTransferCreatedAlert = (response) => {
    showModal({
      title: "",
      fullWidth: false,
      closeCb: handleClose,
      content: (
        <SuccessAlert
          approverId={response?.data?.approverId}
          approverName={response?.data?.approverName}
          closeHandler={handleClose}
        />
      ),
    });
  };

  const handleSendForApproval = async () => {
    hideModal();
    const request = createTransferApprovalRequest(
      transferDetails,
      selectedStudent
    );

    try {
      setIsLoading(true);
      const response = await transferApi(request);
      console.log(response, "response");
      if (response?.code === 200) {
        showModal({
          title: "",
          fullWidth: false,
          closeCb: () => showTransferCreatedAlert(response),
          content: (
            <ApplyMiscChargesAlert
              transferType={adjustmentData?.transferType}
              amount={response?.data?.miscChargeValue}
              timeStamp={response?.data?.timeStamp}
              isMscrChargesAlreadyApplied={
                response?.data?.isMscrChargesAlreadyApplied
              }
              closeHandler={() => showTransferCreatedAlert(response)}
            />
          ),
        });
      }
    } catch (error) {
    } finally {
      setIsLoading(false);
    }
  };

  const validatePendingCheques = () => {
    if (chequeReceipts?.chequeNoList?.length > 0) {
      showModal({
        title: <WarningInfoCircle />,
        maxWidth: "md",
        content: (
          <div style={{ minWidth: "500px" }}>
            <ShowPendingCheques
              chequeNos={chequeReceipts?.chequeNoList}
              psid={chequeReceipts?.psid}
              applicationId={applicationId}
              hideModal={hideModal}
              businessAreaId={chequeReceipts?.businessArea}
              cashierOffice={chequeReceipts?.cashierOffice}
              onProceed={handleSendForApproval}
            />
          </div>
        ),
      });
    } else {
      handleSendForApproval();
    }
  };
  return (
    <>
      {(isLoading || loading || adjustmentLoading) && (
        <ALoader position="fixed" />
      )}
      <div className="card p-4">
        {/* Transfer Summary Row */}
        <div className="row mb-3">
          <div className="form-group col-md-4">
            <label className=" semi-bold text-dark ">Transfer type</label>
            <AInput
              className="form-control text-dark"
              type="text"
              disabled
              style={inputHeight}
              value={adjustmentData?.transferType}
            />
          </div>
          <div className="form-group col-md-4">
            <label className="semi-bold text-dark">Min Receipt Date</label>
            <AInput
              className="form-control text-dark"
              type="text"
              disabled
              style={inputHeight}
              value={"-"}
            />
          </div>
          <div className="form-group col-md-4">
            <label className="semi-bold text-dark">Effective Date</label>
            <AInput
              className="form-control text-dark"
              type="text"
              disabled
              style={inputHeight}
              value={transferDetails?.effectiveDate}
            />
          </div>
        </div>

        {/* Fee Summary */}
        <div className="mb-2">
          <div className="d-flex align-items-center justify-content-between">
            <h6 className="mb-2 bold-heading-label text-dark">
              Fee calculation
            </h6>
            <div>
              <ViewAdjustmentsButton
                applicationId={selectedStudent?.applicationId}
                transferInBU={transferDetails?.businessArea?.label}
                transferOutBU={selectedStudent?.businessAreaDispVal}
                groupedData={groupedData}
              />
            </div>
          </div>
          <div className="d-flex flex-column gap-1">
            <div className="d-flex justify-content-between mb-3">
              <span>Adjustment Amount</span>
              <span>{formattedPrice(adjustmentData?.adjAmount)}</span>
            </div>
          </div>
          <div className="mt-2 bold-heading-label text-dark d-flex justify-content-between">
            Balance Outstanding in TROUT ({selectedStudent?.businessAreaDispVal}
            ):
            <div> {formattedPrice(tInBalanceAmount)} </div>
          </div>
          <div className="mt-2 bold-heading-label   d-flex text-dark justify-content-between">
            Balance Amount in TRIN ({transferDetails?.businessArea?.label}):{" "}
            <div>
              {" "}
              {formattedPrice(adjustmentData?.trinBalancePending || 0)}
            </div>
          </div>
        </div>

        {/* Fee Table */}
        <div className="mt-4 semi-bold color-black">
          TROUT : {selectedStudent?.businessAreaDispVal}
        </div>
        <ADataGrid
          columns={tInColumns}
          rowId={(row) => row.itemType}
          rows={rows}
          autoHeight
          loading={loading}
          pageSize={5}
          noRowsOverlayText="No rows"
          hideFooterPagination
        />
      </div>

      <Footer>
        <div>Verify payments</div>
        <AButton
          onClick={validatePendingCheques}
          className="button_remove_left_margin"
          variant="primary_filled"
        >
          Send for approval
        </AButton>
      </Footer>
    </>
  );
};

export default VerifyPaymentsCard;
